module.exports = __webpack_public_path__ + "static/media/talk3.edc2442f.png";